import { ReactComponent as ArrowRightSvg } from '../../assets/icons/arrow-right.svg';

export const ArrowRightIcon: SvgIcon = (props) => {
    return <ArrowRightSvg {...props} />;
};
